import { Action, combineReducers, configureStore, Reducer, ThunkAction } from '@reduxjs/toolkit';
import { ColumnSortInfo, ReduxAppState } from '@type/app-types';
import columnSortReducer from './reducers/columnSortReducer';

const rootReducer = combineReducers({
    columnSortReducer,
}) as unknown as Reducer<ReduxAppState, Action>;

const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
});

export { store };

export interface ColumnSortState {
    recentColumnSort: Record<string, ColumnSortInfo | undefined>;
}

export const RootState = rootReducer;
export const AppStore = store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
